import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "className", "columns", "columnSize", "gutterSize"];
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { toPx } from '../utils/Styles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getColumnSize = (value, correction) => {
  // subtract correction from % values
  if (typeof value === 'string' && /%$/.test(value)) {
    return `calc(${value} - ${toPx(correction)})`;
  }
  // convert raw numbers to px strings
  if (typeof value === 'number') {
    return toPx(value);
  }
  // leave other string values alone
  return value;
};
const getTemplateColumns = ({
  columns,
  columnSize,
  gutterSize
}) => {
  if (columns) return `repeat(${columns}, 1fr)`;
  const computedColumnSize = getColumnSize(columnSize, gutterSize);
  return `repeat(auto-fit, minmax(${computedColumnSize}, 1fr))`;
};
const getFlexChildFallback = ({
  columns,
  columnSize,
  gutterSize
}) => css(["flex-grow:", ";flex-shrink:1;flex-basis:", ";margin-bottom:0;margin-left:", ";margin-right:0;margin-top:", ";"], typeof columnSize === 'string' && /%$/.test(columnSize) ? '0' : '1', getColumnSize(columns ? `${Math.floor(100 / columns)}%` : columnSize, gutterSize), toPx(gutterSize), toPx(gutterSize));
const CardGrid = styled.div.withConfig({
  displayName: "UICardGrid__CardGrid",
  componentId: "utaukv-0"
})(["display:flex;flex-wrap:wrap;margin-bottom:0;margin-left:-", ";margin-right:0;margin-top:-", ";&& > *{", ";}@supports (display:grid){display:flex;display:grid;grid-column-gap:", ";grid-row-gap:", ";grid-template-columns:", ";margin:0;&& > *{margin:0;}}"], ({
  gutterSize
}) => toPx(gutterSize), ({
  gutterSize
}) => toPx(gutterSize), getFlexChildFallback, ({
  gutterSize
}) => toPx(gutterSize), ({
  gutterSize
}) => toPx(gutterSize), getTemplateColumns);
const CardShim = styled.div.withConfig({
  displayName: "UICardGrid__CardShim",
  componentId: "utaukv-1"
})(["", ";&&{margin-top:0;}@supports (display:grid){display:none;}"], getFlexChildFallback);
export default function UICardGrid(_ref) {
  let {
      children,
      className,
      columns,
      columnSize,
      gutterSize
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CardGrid, Object.assign({}, rest, {
    className: className,
    columnSize: columnSize,
    gutterSize: gutterSize,
    columns: columns,
    children: [children, /*#__PURE__*/_jsx(CardShim, {
      columnSize: columnSize,
      gutterSize: gutterSize,
      columns: columns
    }), /*#__PURE__*/_jsx(CardShim, {
      columnSize: columnSize,
      gutterSize: gutterSize,
      columns: columns
    }), /*#__PURE__*/_jsx(CardShim, {
      columnSize: columnSize,
      gutterSize: gutterSize,
      columns: columns
    }), /*#__PURE__*/_jsx(CardShim, {
      columnSize: columnSize,
      gutterSize: gutterSize,
      columns: columns
    }), /*#__PURE__*/_jsx(CardShim, {
      columnSize: columnSize,
      gutterSize: gutterSize,
      columns: columns
    })]
  }));
}
UICardGrid.propTypes = {
  children: PropTypes.node,
  columns: PropTypes.number,
  columnSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  gutterSize: PropTypes.number,
  expandToFill: PropTypes.bool
};
UICardGrid.defaultProps = {
  columnSize: 295,
  gutterSize: 32
};
UICardGrid.displayName = 'UICardGrid';